<div id="footer">
  <p>
    &copy; 2013-{{ getYear() }} Renaissance Learning, Inc. All rights reserved.
  </p>
</div>
